import * as React from "react";
const SvgFiRrArrowsH = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-arrows-h_svg__a)">
      <path
        fill="#062147"
        d="M23.312 10.013a21 21 0 0 0-.771-.835L19.713 6.3a1 1 0 0 0-1.426 1.4l2.834 2.885c.108.108.244.255.389.414H2.555c.146-.16.284-.308.4-.42L5.779 7.7a1 1 0 0 0-1.426-1.4L1.53 9.172c-.2.2-.487.513-.777.84A3 3 0 0 0 0 11.996v.012a3 3 0 0 0 .754 1.983c.289.325.573.636.769.832l2.83 2.879a1 1 0 0 0 1.426-1.4l-2.835-2.886A13 13 0 0 1 2.555 13H21.51c-.145.16-.283.308-.4.42l-2.823 2.88a1 1 0 1 0 1.426 1.4l2.822-2.873c.2-.2.486-.513.777-.84a3 3 0 0 0 0-3.976"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-arrows-h_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrArrowsH;
